<template>
  <div ref="CONTRAT_LIST" :class="isCardView ? '' : 'section'">
    <section-header
v-if="!hideTitle && !isCardView"
                    ref="CONTRAT_LIST"
                    :ressource="ressource"
                    :is-extended="extended"
                    :dialog="dialog"
                    :can-add="canAdd"
                    :add-label="addLabel"
                    :fiche=fiche
                    :show-search=showSearch
                    :add-disabled=addDisabled
                    :show-toggle="showToggle"
                    @search=onSearchTextUpdated
                    @extended=setExtended
                    @close-dialog=closeSection
                    @card-view=cardView
                    @callback=addItem>
    </section-header>
    <list-header
v-if="isCardView"
                 :placeholder="placeholder"
                 :show-search=showSearch
                 :is-card-view="isCardView"
                 :show-toggle="showToggle"
                 @card-view=cardView
                 @search=onSearchTextUpdated>
    </list-header>
    <div v-if="extended">
      <v-row class="ma-0 filters-row" no-gutters>
        <v-col v-for="(item, index) in filterableHeaders" :key="index" cols="auto" class="pr-2">
          <data-table-filter
:header-value="item.value"
                             :label="item.text"
                             :column-config="getConfig(item.value)"
                             :current-filters="getFilters(item.value)"
                             @apply="applyFilters">
          </data-table-filter>
        </v-col>
        <!-- Filtre « Période » : remplace les pastilles « Date de début » et
             « Date de fin », et s'applique à la date de début du contrat. -->
        <v-col cols="auto" class="pr-2">
          <section-contrat-periode-filter
:current-range="currentPeriode"
                                          label="Période"
                                          @apply="applyFilters">
          </section-contrat-periode-filter>
        </v-col>
        <!-- Filtre de sélection : purement client, il ne rejoint jamais activeFilters. -->
        <v-col v-if="selectionEnabled" cols="auto" class="pr-2">
          <data-table-filter
:header-value="'selection'"
                             label="Sélection"
                             :column-config="selectionColumnConfig"
                             :current-filters="selectionCurrentFilters"
                             @apply="applySelectionFilter">
          </data-table-filter>
        </v-col>
      </v-row>
      <div v-if="!isCardView">
        <!-- Barre de sélection : entre la barre de filtres et les titres de colonnes. -->
        <section-contrat-selection-bar
v-if="selectionEnabled"
                                       :selected-count="selectedCount">
          <!-- Actions de masse : le slot est posé par la barre depuis l'US1. -->
          <template #actions>
            <loader-button
type="button"
                           label="Générer les DPAE"
                           :outlined="true"
                           :loading="dpaeEnCours || dpaePreparation"
                           @callback="ouvrirConfirmationDpae">
            </loader-button>
            <div class="ms-3">
              <loader-button
type="button"
                             label="Envoyer en signature électronique"
                             :outlined="true"
                             :loading="signaturePreparation || signatureEnCours"
                             @callback="ouvrirSignatureMasse">
              </loader-button>
            </div>
          </template>
        </section-contrat-selection-bar>

        <!-- Avancement du lot : le traitement peut durer plusieurs minutes. -->
        <section-progression-masse
:visible="dpaeEnCours"
                                   :traites="dpaeTraites"
                                   :total="dpaeTotal"
                                   libelle="Génération des DPAE en cours"
                                   unite="DPAE">
        </section-progression-masse>
        <section-progression-masse :visible="signatureEnCours"
                                   :traites="signatureTraites"
                                   :total="signatureTotal"
                                   libelle="Envoi en signature en cours"
                                   unite="contrats"
                                   participe="traités">
        </section-progression-masse>

        <!-- Objet commun des contrats sans objet, pendant l'envoi en signature en masse. -->
        <section-objet-commun-dialog
:visible="objetVisible"
                                     :selectionnes="objetSelectionnes"
                                     :sans-objet="objetSansObjet"
                                     :en-cours="objetEnCours"
                                     @valider="validerObjet"
                                     @annuler="annulerObjet">
        </section-objet-commun-dialog>

        <!-- Choix du modèle de contrat des contrats qui en demandent un, pendant l'envoi en masse. -->
        <section-modele-contrat-dialog
:visible="modeleVisible"
                                       :selectionnes="modeleSelectionnes"
                                       :a-choisir="modeleAChoisir"
                                       :modeles="modeleOptions"
                                       :en-cours="modeleEnCours"
                                       @valider="validerModele"
                                       @annuler="annulerModele">
        </section-modele-contrat-dialog>
        <v-data-table-server
v-model="selectionModel"
                             v-model:sort-by="sortBy" dense
                                   fixed-header
                                   :headers="headers"
                                   :items="displayedItems"
                                   :items-length="filteredCount"
                                   :items-per-page="-1"
                                   :must-sort="true"
                                   :mobile-breakpoint="100"
                                   class="white"
                                   :hover=true
                                   item-value="id"
                                   no-data-text="Aucune donnée"
                                   :disable-pagination="true"
                                   :hide-default-footer="true"
                                   :show-select="showSelect"
                                   @update:sort-by="onSortUpdate"
                                   @click:row="selectItem">
          <!-- Case maîtresse, en première colonne et sans libellé. C'est la nôtre et non
               celle de Vuetify, dont la portée serait limitée à la page courante : elle
               couvre tous les contrats filtrés, toutes pages confondues. Le libellé passe
               par `aria-label` et l'infobulle, sur le modèle de SectionCreneaux. -->
          <template #[`header.data-table-select`]>
            <v-tooltip text="Tout sélectionner" location="top">
              <template #activator="{ props }">
                <div v-bind="props" class="d-flex align-center">
                  <!-- `key` dérivée de l'état logique : la case garde sinon un état interne
                       propre (Vuetify est en one-way ici), qui peut diverger de nos données
                       et afficher « cochée » alors que rien n'est sélectionné. -->
                  <!-- `v-checkbox-btn` et non `v-checkbox` : c'est le composant dont Vuetify
                       se sert pour les cases de lignes et pour sa propre case d'en-tête. La
                       nôtre s'aligne donc exactement sur sa colonne, sans style ajouté. -->
                  <v-checkbox-btn
:key="etatCaseMaitresse"
                                  :model-value="allFilteredSelected"
                                  :indeterminate="selectionIndeterminate"
                                  :disabled="loading || selectionLoading"
                                  aria-label="Tout sélectionner"
                                  @update:model-value="toggleSelectAll(!allFilteredSelected)">
                  </v-checkbox-btn>
                </div>
              </template>
            </v-tooltip>
          </template>
          <template #[`item.projetId`]="{ item }">
             <div :class="getClass(item)">{{ getLabel('projetId', item.projetId, item ) }}</div>
          </template>
          <template #[`item.codeCheque`]="{ item }">
             <div :class="getClass(item)">{{ getLabel('codeCheque', item.codeCheque, item ) }}</div>
          </template>
          <template #[`item.salarieId`]="{ item }">
             <div :class="getClass(item)">{{ getLabel('salarieId', item.salarieId, item ) }}</div>
          </template>
          <template #[`item.emploiId`]="{ item }">
             <div :class="getClass(item)">{{ getLabel('emploiId', item.emploiId, item ) }}</div>
          </template>
          <template #[`item.lieuId`]="{ item }">
             <div :class="getClass(item)">{{ getLabel('lieuId', item.lieuId, item ) }}</div>
          </template>
          <template #[`item.dateDebut`]="{ item }">
             <div :class="getClass(item)">{{ getLabel('dateDebut', item.dateDebut, item ) }}</div>
          </template>
          <template #[`item.dateFin`]="{ item }">
             <div :class="getClass(item)">{{ getLabel('dateFin', item.dateFin, item ) }}</div>
          </template>
          <template #[`item.statut`]="{ item }">
             <div :class="getClass(item)">{{ getLabel('statut', item.statut, item ) }}</div>
          </template>
          <template #[`item.statutDashboard`]="{ item }">
             <div :class="getClass(item)">{{ getLabel('statutDashboard', item.statutDashboard, item ) }}</div>
          </template>
          <template #[`item.action`]="{ item }">
            <v-row class="m-0">
              <div v-if="hasDocument(item)" class="col-2">
                <v-icon :disabled="actionProgress" size="25" :color="getDocumentColor(item)" @click.stop="displayDocument(item)">{{mdiDocument(item)}}</v-icon>
              </div>
              <div v-if="canDelete(item)" class="col-2">
                <v-icon :disabled="actionProgress" size="25" color="border" @click.stop="deleteItem(item)">fas fa-trash-can</v-icon>
              </div>
              <div v-if="canUpdate(item)" class="col-2">
                <v-icon :disabled="actionProgress" size="25" color="border" @click.stop="updateItem(item)">fas fa-pencil</v-icon>
              </div>
              <div v-if="hasAction(item)" class="col-2">
                <v-icon :disabled="actionProgress" size="25" :color="getActionColor(item)" @click.stop="execAction(item)">{{mdiAction(item)}}</v-icon>
              </div>
            </v-row>
          </template>
          <template v-for="(item, index) in headers" :key="index" #[`header.${item.value}`]>
            <div style="display: flex; align-items: center;">
              <div>{{ item.text }}</div>
              <v-icon v-if="getSortOrder(item.value)" class="sort-icon">
                {{ getSortOrder(item.value) === 'asc' ? 'fas fa-arrow-up' : 'fas fa-arrow-down' }}
              </v-icon>
            </div>
          </template>
        </v-data-table-server>
        <v-row v-if="showCount" class="m-0">
          <v-col cols="11">
            <v-pagination v-if="pageCount > 1" v-model="page" :length="pageCount" :total-visible="10" class="pagination-color"></v-pagination>
          </v-col>
          <v-col class="text-right align-content-center">
            {{ filteredCount }}/{{ totalCount }}
          </v-col>
        </v-row>
      </div>
    </div>
      <div v-if="!hasItems && isCardView" class="empty-list-container">
        <img src="@/assets/SVG/empty-list.svg" class="empty-list-logo"/>
        <div class="empty-list-label">{{ getNewLabel() }}</div>
      </div>
    <div v-if="canAdd && isCardView" class="pt-3">
      <v-btn
class="base"
             :outlined="true"
             :loading="loading"
             :block="true"
             variant="flat"
             @click="addItem">
        {{ addLabel }}
      </v-btn>
    </div>
    <div v-if="extended" class="d-flex flex-row-reverse">
      <div v-for="(button, index) in extraButtons" :key="index">
        <loader-button
class="ms-2"
                       :outlined="button.outlined"
                       :type="button.type"
                       :label="button.label"
                       :disabled="button.disabled"
                       @callback="button.callback()">
        </loader-button>
      </div>
    </div>
    <section-container
:section="section"
                       :dialog-open="dialogOpen"
                       :extended="true"
                       :fullscreen="fullscreen"
                       @close-dialog="closeDialog"
                       @saved="saved"
                       @updated="setUpdated">
    </section-container>
  </div>
</template>

<script lang="ts">
  import SectionContratList from '@/generated/sections/SectionContratList.vue';
  import { Alerts } from '@/framework/base/helpers/Alerts';
  import Contrat, { ContratStatutDashboards, ContratStatuts } from '@/generated/classes/Contrat';
  import Paie, { PaieStatuts } from '@/generated/classes/Paie';
  import Projet from '@/generated/classes/Projet';
  import { storeContrat, storePaie } from '@/generated/stores';
  import ContratExtend from '@/extend/classes/Contrat';
  import { RessourceFwkSection, FwkSections } from '@/ressources/globalRessources';
  import { isMobile } from '@/style/StyleHelpers';
  import Html from '@/framework/base/classes/Html';
  import Route from '@/generated/classes/Route';
  import { Fiches } from '@/generated/classes/AppSchema';
  import { ColumnConfig, ColumnFilter, DateRange, ListChoix } from '@/generated/classes/ListData';
  import { defineComponent, type PropType } from "vue";
  import ListData, {ListFilter} from "@/extend/classes/ListData.ts";
  import SectionHeader from '@/framework/base/components/SectionHeader.vue';
  import SectionContainer from '@/framework/base/components/SectionContainer.vue';
  import DataTableFilter from '@/framework/base/components/DataTableFilter.vue';
  import ListHeader from '@/framework/base/components/ListHeader.vue';
  import LoaderButton from '@/framework/base/components/LoaderButton.vue';
  import SectionContratSelectionBar from '@/custom/sections/SectionContratSelectionBar.vue';
  import SectionContratPeriodeFilter from '@/custom/sections/SectionContratPeriodeFilter.vue';
  import SectionProgressionMasse from '@/custom/sections/SectionProgressionMasse.vue';
  import Dialog from '@/generated/classes/Dialog';
  import { openAlert } from '@/framework/base/components/SectionAlert.vue';
  import {
    ventilerDpae,
    genererDpaeParLot,
    type VentilationDpae,
    type ResultatDpaeMasse,
  } from '@/custom/helpers/dpaeMasse';
  import { titreModale, detailVentilation, regrouperMotifs } from '@/custom/helpers/messagesMasse';
  import {
    executerControles, creerSourceControle, type IssueControles, type Exclusion,
  } from '@/custom/helpers/signatureMasse';
  import {
    repartirEnvoi, envoyerSignatureParLot, neutraliserToucheEntree,
    STATUTS_ENVOYABLES, SEUIL_AVERTISSEMENT_SIGNATURE, BOUTON_ENVOI,
    resultatVide, resultatsDe, ISSUE_A_COMPLETER, ISSUE_ECHEC,
    type ResultatEnvoiSignature,
  } from '@/custom/helpers/signatureMasseEnvoi';
  import {
    creerEtapeDocument, MANQUE_EMPLOYEUR_INCOMPLET, MANQUE_SALARIE_INCOMPLET, MANQUE_SALARIE_ABSENT,
    MANQUE_CRENEAUX_MANQUANTS,
  } from '@/custom/helpers/signatureMasseDocument';
  import { creerEtapeSociete } from '@/custom/helpers/signatureMasseSociete';
  import {
    creerEtapeObjetCommun, MANQUE_OBJET, type SaisieObjet, type BilanObjet,
  } from '@/custom/helpers/signatureMasseObjet';
  import { type ControleSignatureMasseManqueCodes } from '@/generated/classes/ResultatContratMasse';
  import SectionObjetCommunDialog from '@/custom/sections/SectionObjetCommunDialog.vue';
  import {
    creerEtapeModele, MANQUE_MODELE_A_CHOISIR, MANQUE_AUCUN_MODELE, type ChoixModele, type BilanModele,
  } from '@/custom/helpers/signatureMasseModele';
  import SectionModeleContratDialog, { type ModeleProposable } from '@/custom/sections/SectionModeleContratDialog.vue';

  // Au-delà de ce nombre de contrats, la confirmation avertit de la durée du traitement : chaque
  // génération coûte au serveur deux scans de droits complets puis une mise à jour intégrale du
  // contrat, son seuil d'alerte de performance étant à 3 s par appel.
  const SEUIL_AVERTISSEMENT_DPAE = 50;

  // Valeurs du filtre de sélection.
  const SELECTION_ALL = -1;
  const SELECTION_SELECTED = 1;
  const SELECTION_UNSELECTED = 0;

  export default defineComponent({
    name: 'SectionContratListExtend',
    // Le template étant redéfini ici, les composants qu'il utilise sont réenregistrés
    // explicitement plutôt que de dépendre de la fusion d'options avec le parent généré.
    components: {
      SectionHeader,
      SectionContainer,
      DataTableFilter,
      ListHeader,
      LoaderButton,
      SectionContratSelectionBar,
      SectionContratPeriodeFilter,
      SectionProgressionMasse,
      SectionObjetCommunDialog,
      SectionModeleContratDialog,
    },
    extends: SectionContratList,
    props: {
      projet: {
        type: Object as PropType<Projet>,
        required: true,
      },
    },
    data () {
      return {
        isMobile: isMobile(),
        lockAction: false,
        // Source de vérité de la sélection. On conserve des ids et non les objets rendus par
        // le tableau : la sélection doit survivre à un changement de filtres, y compris pour
        // les contrats qui ne correspondent plus aux filtres actifs.
        selectedIds: [] as number[],
        selectionFilter: SELECTION_ALL,
        // Ids de tous les contrats correspondant aux filtres serveur actifs, toutes pages
        // confondues : base du "Tout sélectionner" et de l'état de la case maîtresse.
        filteredIds: [] as number[],
        filteredIdsSignature: '',
        selectionLoading: false,
        // Contrats déjà rapatriés, indexés par id : `loadFilteredIds` récupère les objets complets
        // du périmètre filtré, autant les conserver pour ventiler la sélection sans appel de plus.
        contratsParId: {} as Record<number, Contrat>,
        // Deux états distincts : `dpaePreparation` couvre la ventilation et la confirmation (le
        // bouton s'anime), `dpaeEnCours` uniquement le lot lui-même (la modale de progression
        // s'affiche). Les confondre montrerait une progression « 0 / 0 » avant toute confirmation.
        dpaePreparation: false,
        dpaeEnCours: false,
        dpaeTraites: 0,
        dpaeTotal: 0,
        // Contrôles préalables à l'envoi en signature, y compris le temps où l'utilisateur complète
        // les informations société dans une modale : le bouton ne peut pas être relancé entre-temps.
        signaturePreparation: false,
        // Envoi du lot, après confirmation : la modale de progression s'affiche (même découpage que la DPAE).
        signatureEnCours: false,
        signatureTraites: 0,
        signatureTotal: 0,
        // Modale de saisie de l'objet commun (OVA-4980), pilotée par l'étape objet via `saisieObjet`.
        objetVisible: false,
        objetSelectionnes: 0,
        objetSansObjet: 0,
        objetEnCours: false,
        objetReponse: null as ((objet: string | null) => void) | null,
        // Modale de choix du modèle (OVA-4981), pilotée par l'étape modèle via `choixModele`.
        modeleVisible: false,
        modeleSelectionnes: 0,
        modeleAChoisir: 0,
        modeleOptions: [] as ModeleProposable[],
        modeleEnCours: false,
        modeleReponse: null as ((contratTemplateId: number | null) => void) | null,
        idsRequestId: 0,
        listRequestId: 0,
      };
    },
    computed: {
      headers (): any {
        if (this.projet && this.projet.id) {
          return [
            {text: "Code", value: 'codeCheque', cellClass: '', sortable: true},
            {text: "Salarié", value: 'salarieId', cellClass: '', sortable: true},
            {text: "Emploi", value: 'emploiId', cellClass: '', sortable: true},
            {text: "Libellé du lieu", value: 'lieuId', cellClass: '', sortable: true},
            {text: "Date de début", value: 'dateDebut', cellClass: '', sortable: true},
            {text: "Date de fin", value: 'dateFin', cellClass: '', sortable: true},
            {text: "Statut", value: 'statut', cellClass: '', sortable: true},
            {
              text: 'Action(s)',
              width: '20%',
              value: 'action',
              cellClass: 'iterate-cell-class iterate-cell-action',
              sortable: false
            },
          ];
        } else {
          return [
            {text: "Projet", value: 'projetId', cellClass: '', sortable: true},
            {text: "Code", value: 'codeCheque', cellClass: '', sortable: true},
            {text: "Salarié", value: 'salarieId', cellClass: '', sortable: true},
            {text: "Emploi", value: 'emploiId', cellClass: '', sortable: true},
            {text: "Libellé du lieu", value: 'lieuId', cellClass: '', sortable: true},
            {text: "Date de début", value: 'dateDebut', cellClass: '', sortable: true},
            {text: "Date de fin", value: 'dateFin', cellClass: '', sortable: true},
            {text: "Statut", value: 'statutDashboard', cellClass: '', sortable: true},
          ];
        }
      },
      addLabel (): string {
        let res = '';
        if (!this.isMobile) {
          res = RessourceFwkSection(FwkSections.NEW_CONTRAT).label;
        }
        return res;
      },

      canAdd() : boolean {
        return this.projet && this.projet.id > 0;
      },
      items(): unknown[] {
        if (!this.isInitialised || (this.route && (this.route.sectionObjId != this.lastRoute.sectionObjId) || (JSON.stringify(this.route.attribut) != JSON.stringify(this.lastRoute.attribut)))) {
          this.routeFilter();
          this.setLastRoute();
          this.loadTable();
          this.isInitialised = true;
        }
        return this.listData.reccords;
      },

      /**
       * Colonnes portant une pastille de filtre. « Date de début » et « Date de
       * fin » en sont retirées : elles restent des COLONNES du tableau, mais
       * leur filtrage passe désormais par la pastille « Période » unique.
       * On filtre ici plutôt que de forcer `isFilterable` à false via
       * getConfig, qui renvoie ses ColumnConfig par référence — une mutation
       * contaminerait tous ses lecteurs.
       */
      filterableHeaders (): any[] {
        return this.headers.filter((entete: any) => this.getConfig(entete.value).isFilterable
          && entete.value != 'dateDebut' && entete.value != 'dateFin');
      },
      /** Plage actuellement appliquée sur dateDebut, pour l'affichage de la pastille. */
      currentPeriode (): DateRange | null {
        const filtres = this.getFilters('dateDebut');
        return filtres.length > 0 ? filtres[0].dateRange : null;
      },

      // La sélection de masse ne concerne que la liste des contrats d'un projet. Hors projet
      // (tableau de bord, notifications), la liste reste strictement inchangée.
      selectionEnabled (): boolean {
        return this.projet != undefined && this.projet.id > 0;
      },
      showSelect (): boolean {
        return this.selectionEnabled;
      },
      selectedCount (): number {
        return this.selectedIds.length;
      },
      allFilteredSelected (): boolean {
        return this.filteredIds.length > 0 && this.filteredIds.every((id) => this.selectedIds.includes(id));
      },
      selectionIndeterminate (): boolean {
        return !this.allFilteredSelected && this.filteredIds.some((id) => this.selectedIds.includes(id));
      },
      // Identité de rendu de la case maîtresse, pour la resynchroniser sur l'état logique.
      etatCaseMaitresse (): string {
        if (this.allFilteredSelected) return 'tout';
        return this.selectionIndeterminate ? 'partiel' : 'aucun';
      },
      selectionFilterActive (): boolean {
        return this.selectionFilter == SELECTION_SELECTED || this.selectionFilter == SELECTION_UNSELECTED;
      },
      // v-model du tableau. Le setter ne touche qu'aux lignes de la page courante afin de ne
      // jamais perdre la sélection portant sur les autres pages.
      selectionModel: {
        get (): number[] {
          return this.selectedIds;
        },
        set (value: number[]): void {
          const pageIds = this.pageIds;
          const offPage = this.selectedIds.filter((id) => !pageIds.includes(id));
          const onPage = value.filter((id) => pageIds.includes(id));
          this.selectedIds = offPage.concat(onPage);
        },
      },
      pageIds (): number[] {
        return this.displayedItems.map((contrat) => contrat.id);
      },
      // Taille de page réellement affichée. Quand le filtre de sélection est actif, on
      // rapatrie tout (pageLimit = -1) pour filtrer et paginer côté client.
      displayPageLimit (): number {
        return 20;
      },
      pageLimit (): number {
        return this.selectionFilterActive ? -1 : this.displayPageLimit;
      },
      // Typé en ContratExtend (et non unknown[]) pour que le tableau et ses slots héritent
      // du bon type d'item, comme l'attendent les méthodes du parent généré.
      selectionFilteredRecords (): ContratExtend[] {
        const records = this.items as ContratExtend[];
        if (!this.selectionFilterActive) {
          return records;
        }
        if (this.selectionFilter == SELECTION_SELECTED) {
          return records.filter((contrat) => this.selectedIds.includes(contrat.id));
        }
        return records.filter((contrat) => !this.selectedIds.includes(contrat.id));
      },
      displayedItems (): ContratExtend[] {
        if (!this.selectionFilterActive) {
          return this.selectionFilteredRecords;
        }
        const start = (this.pageNumber - 1) * this.displayPageLimit;
        return this.selectionFilteredRecords.slice(start, start + this.displayPageLimit);
      },
      pageCount (): number {
        if (!this.selectionFilterActive) {
          return this.listData.pageCount;
        }
        return Math.ceil(this.selectionFilteredRecords.length / this.displayPageLimit);
      },
      filteredCount (): number {
        if (!this.selectionFilterActive) {
          return this.listData.filteredCount;
        }
        return this.selectionFilteredRecords.length;
      },
      selectedFilteredCount (): number {
        return this.filteredIds.filter((id) => this.selectedIds.includes(id)).length;
      },
      // Config synthétique : ce filtre n'existe pas côté serveur, il est construit ici.
      // DataTableFilter ajoute lui-même l'option "Tous".
      selectionColumnConfig (): ColumnConfig {
        const config = new ColumnConfig();
        config.name = 'selection';
        config.isFilterable = true;
        config.type = '';
        const selected = new ListChoix();
        selected.value = SELECTION_SELECTED;
        selected.text = 'Sélectionné(s)';
        selected.count = this.selectedFilteredCount;
        const unselected = new ListChoix();
        unselected.value = SELECTION_UNSELECTED;
        unselected.text = 'Non sélectionné(s)';
        unselected.count = this.filteredIds.length - this.selectedFilteredCount;
        config.choix = [selected, unselected];
        return config;
      },
      selectionCurrentFilters (): ListChoix[] {
        if (!this.selectionFilterActive) {
          return [];
        }
        const choix = new ListChoix();
        choix.value = this.selectionFilter;
        choix.text = this.selectionFilter == SELECTION_SELECTED ? 'Sélectionné(s)' : 'Non sélectionné(s)';
        return [choix];
      },
      // Signature du périmètre filtré : sert à ne recharger les ids que lorsque ce périmètre
      // change réellement. Le tri et la pagination en sont volontairement exclus, car ils ne
      // modifient pas l'ensemble des contrats concernés.
      filterSignature (): string {
        const scope = this.activeFilters.map((filter: ColumnFilter) => {
          return { name: filter.name, filters: filter.filters };
        });
        return JSON.stringify(scope) + '|' + this.searchText;
      },
    },
    methods: {
      /**
       * Idempotent : ListBase.resetActiveFilters rejoue defaultFilter() à
       * chaque remise à zéro d'une colonne (effacer la période, par exemple).
       * Sans cette garde, les filtres projetId et codeCheque s'empileraient en
       * doublons à chaque appel. On ne vide surtout PAS activeFilters ici :
       * resetActiveFilters n'efface qu'une seule colonne, un vidage global
       * emporterait les filtres Salarié / Emploi / Statut en cours.
       */
      defaultFilter (): void {
        if (!this.activeFilters.some((filtre: ColumnFilter) => filtre.name == 'codeCheque')) {
          const triParDefaut = new ColumnFilter();
          triParDefaut.name = 'codeCheque';
          triParDefaut.sortDescending = true;
          this.activeFilters.push(triParDefaut);
        }
        if (this.projet && this.projet.id
          && !this.activeFilters.some((filtre: ColumnFilter) => filtre.name == 'projetId')) {
          const filtreProjet = new ColumnFilter();
          const choix = new ListChoix();
          choix.value = this.projet.id;
          filtreProjet.name = 'projetId';
          filtreProjet.staticFilter = true;
          filtreProjet.filters.push(choix);
          this.activeFilters.push(filtreProjet);
        }
      },
      routeFilter(): void {
        this.activeFilters = [];
        this.pageNumber = 1;
        this.defaultFilter();

        if (
            this.route &&
            this.route.attribut &&
            this.route.attribut.columnsFilter &&
            this.route.attribut.columnsFilter.length > 0
        ) {
          this.route.attribut.columnsFilter.forEach(col => {
            const columnFilter = new ColumnFilter();
            columnFilter.name = col.name;
            columnFilter.staticFilter = col.staticFilter;

            col.filters.forEach(f => {
              const choix = new ListChoix();
              choix.value = f.value;
              choix.text = f.text;
              choix.dateRange = f.dateRange;
              columnFilter.filters.push(choix);
            });

            this.activeFilters.push(columnFilter);
          });
        }
      },
      // Surcharge : même corps que la section générée, plus le rafraîchissement des ids
      // filtrés et une garde anti-course (filtres enchaînés rapidement).
      loadTable (): void {
        // Pas de garde « if (this.loading) return » ici, contrairement à la
        // section générée : elle abandonnerait silencieusement un rechargement
        // demandé pendant qu'un autre est en vol (typiquement l'application
        // d'un filtre juste après l'ouverture), laissant la liste sur des
        // données périmées. La cohérence est assurée par `listRequestId`, qui
        // ne retient que la réponse du dernier appel.
        this.loading = true;
        const requestId = ++this.listRequestId;
        Contrat.list(this.filter).then((res) => {
          if (requestId != this.listRequestId) return;
          this.listData = new ListData();
          this.listData = res;
          this.pageNumber = res.currentPage;
          this.loading = false;
          this.loadFilteredIds();
          if (this.isAbstract && res.reccords.length == 0 && this.canAdd) {
            this.addItem();
          }
        }).catch(() => {
          if (requestId == this.listRequestId) {
            this.loading = false;
          }
        });
        this.pageNumber = 1;
      },
      // Récupère les ids de tous les contrats du périmètre filtré, toutes pages confondues.
      // pageLimit = -1 : le serveur n'ajoute alors aucune clause LIMIT.
      // Résout avec les ids récupérés : l'appelant ne doit PAS relire
      // `this.filteredIds` après l'await, un rechargement concurrent (le
      // computed `items` peut relancer loadTable) ayant pu invalider ce
      // résultat entre-temps.
      loadFilteredIds (force = false): Promise<number[]> {
        if (!this.selectionEnabled) return Promise.resolve(this.filteredIds);
        const signature = this.filterSignature;
        if (!force && signature == this.filteredIdsSignature) return Promise.resolve(this.filteredIds);

        const idsFilter = new ListFilter();
        idsFilter.page = 0;
        idsFilter.pageLimit = -1;
        idsFilter.displayedHeaders = this.displayedHeaders;
        idsFilter.searchText = this.searchText;
        idsFilter.columnsFilter = this.activeFilters;
        idsFilter.selectedId = 0;

        const requestId = ++this.idsRequestId;
        this.selectionLoading = true;
        return Contrat.list(idsFilter).then((res) => {
          const ids: number[] = [];
          res.reccords.forEach((item) => {
            const contrat = item as Contrat;
            ids.push(contrat.id);
            // Conservé pour ventiler la sélection sans requête supplémentaire.
            this.contratsParId[contrat.id] = contrat;
          });
          // Garde anti-course : on ne publie dans l'état que le dernier appel,
          // mais on renvoie toujours les ids de CET appel à son appelant.
          if (requestId == this.idsRequestId) {
            this.filteredIds = ids;
            this.filteredIdsSignature = signature;
          }
          return ids;
        }).catch(() => {
          // Périmètre inconnu : la barre reste utilisable, sans "Tout sélectionner".
          return [] as number[];
        }).finally(() => {
          if (requestId == this.idsRequestId) {
            this.selectionLoading = false;
          }
        });
      },
      // Neutralise les rechargements pendant un lot : la section généré s'abonne à SignalR
      // (ContratUpdated -> reloadTable), or chaque DPAE générée déclenche cet événement. Sans cette
      // garde, un lot de N contrats provoquerait N rechargements complets de la liste, concurrents du
      // traitement. Un unique rechargement est fait à la fin (voir executerDpaeMasse).
      reloadTable (): void {
        if (!this.actionProgress) {
          this.loadTable();
        }
      },

      /**
       * Objets contrats de la sélection courante. La sélection ne retient que des ids et survit aux
       * changements de filtres (US1) : certains ids peuvent donc être hors du périmètre rapatrié. Les
       * manquants sont récupérés un par un, ce qui reste marginal en pratique.
       */
      async contratsSelectionnes (): Promise<Contrat[]> {
        const manquants = this.selectedIds.filter((id: number) => !this.contratsParId[id]);
        for (const id of manquants) {
          try {
            this.contratsParId[id] = await Contrat.get(id);
          } catch {
            // Contrat illisible (droits, suppression concurrente) : on l'ignore plutôt que
            // d'interrompre l'action. Il ne sera ni compté ni traité.
          }
        }
        return this.selectedIds
          .map((id: number) => this.contratsParId[id])
          .filter((contrat: Contrat | undefined) => contrat != undefined);
      },

      /**
       * Message de la confirmation. Les formulations sont reprises au mot près de la spécification
       * (aucun accord de nombre ni de genre) : seule la mise en forme est ajoutée, les effectifs
       * étant mis en évidence pour être lisibles d'un coup d'œil.
       */
      messageConfirmationDpae (selectionnes: number, ventilation: VentilationDpae): string {
        const eligibles = ventilation.eligibles.length;
        let message = titreModale('Génération des DPAE');

        if (selectionnes == eligibles) {
          message += `Vous vous apprêtez à générer <strong>${eligibles} DPAE</strong>.`;
        } else {
          message += `Vous avez sélectionné <strong>${selectionnes}</strong> contrat(s).<br>`
            + `Parmi ceux-ci, vous vous apprêtez à générer <strong>${eligibles} DPAE</strong>.`;

          const detail: string[] = [];
          if (ventilation.informationsManquantes > 0) {
            detail.push(`<strong>${ventilation.informationsManquantes}</strong> contrat(s) :`
              + ' informations manquantes, DPAE impossible pour le moment.');
          }
          if (ventilation.dejaRealisees > 0) {
            detail.push(`<strong>${ventilation.dejaRealisees}</strong> contrat(s) :`
              + ' DPAE déjà réalisée.');
          }
          if (ventilation.nonGerees > 0) {
            detail.push(`<strong>${ventilation.nonGerees}</strong> contrat(s) :`
              + ' DPAE à réaliser par vos soins.');
          }
          message += detailVentilation(detail);
        }

        if (eligibles > SEUIL_AVERTISSEMENT_DPAE) {
          message += '<div style="padding-top:14px">Le traitement portera sur un grand nombre de'
            + ' contrats et peut durer plusieurs minutes.<br>Vous pouvez réduire la sélection à'
            + ' l\'aide des filtres.</div>';
        }

        return message;
      },

      /** Ventile la sélection, demande confirmation, puis lance le lot si l'utilisateur accepte. */
      async ouvrirConfirmationDpae (): Promise<void> {
        if (this.dpaeEnCours || this.dpaePreparation || this.signaturePreparation || this.signatureEnCours) return;

        this.dpaePreparation = true;
        try {
          const ventilation = ventilerDpae(await this.contratsSelectionnes());
          if (!await this.confirmerDpae(ventilation)) return;
          if (ventilation.eligibles.length == 0) return;
          await this.executerDpaeMasse(ventilation.eligibles);
        } finally {
          this.dpaePreparation = false;
        }
      },

      /** Demande confirmation et renvoie `true` si l'utilisateur a explicitement accepté. */
      async confirmerDpae (ventilation: VentilationDpae): Promise<boolean> {
        const dialog = new Dialog();
        dialog.label = this.messageConfirmationDpae(this.selectedIds.length, ventilation);
        // Pas de helper pour un couple Annuler/OK : `Alerts.message` ne résout que sur « OK » et
        // `Alerts.alertDelete` impose « Confirmer ». `openAlert` renvoie le libellé du bouton cliqué.
        dialog.buttons.push('Annuler');
        dialog.buttons.push('OK');

        // `openAlert` est posé par App.vue au démarrage ; on ne présume pas de sa présence, et son
        // absence vaut refus (on ne lance jamais un lot sans confirmation explicite).
        if (!openAlert) return false;
        const reponse = await openAlert(dialog);
        // SectionAlert mappe Entrée -> « Confirmer » et Échap -> « Annuler », quels que soient les
        // boutons affichés : seule la valeur exacte « OK » vaut accord, tout le reste annule.
        return reponse == 'OK';
      },

      /** Exécute le lot, affiche le compte rendu, puis recharge la liste une seule fois. */
      async executerDpaeMasse (eligibles: Contrat[]): Promise<void> {
        this.dpaeTotal = eligibles.length;
        this.dpaeTraites = 0;
        this.dpaeEnCours = true;
        // Suspend les rechargements déclenchés par SignalR pendant toute la durée du lot.
        this.actionProgress = true;

        let resultat: ResultatDpaeMasse = { demandes: 0, succes: 0, ignores: 0, echecs: [] };
        try {
          resultat = await genererDpaeParLot(eligibles, (traites: number) => {
            this.dpaeTraites = traites;
          });
        } finally {
          this.dpaeEnCours = false;
          this.actionProgress = false;
        }

        let message = titreModale('Résultat de la génération des DPAE')
          + `<strong>${resultat.succes} DPAE</strong> ont été générées avec succès.`;
        // Les lignes ne sont affichées que si elles portent quelque chose : annoncer « 0 DPAE n'ont
        // pas pu être générées » serait du bruit.
        const detail: string[] = [];
        // Le serveur relit le statut en base : un contrat annoncé éligible à la confirmation a pu
        // changer entre-temps, ou être présent deux fois dans la sélection. Le dire évite que l'écart
        // entre le nombre annoncé et le nombre généré passe pour une perte.
        if (resultat.ignores > 0) {
          detail.push(`<strong>${resultat.ignores} contrat(s)</strong> n'étaient plus à générer au`
            + ' moment du traitement.');
        }
        regrouperMotifs(resultat.echecs).forEach(({ motif, nombre }) => {
          detail.push(`<strong>${nombre} DPAE</strong> : ${motif}.`);
        });
        message += detailVentilation(detail);
        const dialog = new Dialog();
        dialog.label = message;
        // `buttons` laissé vide : Alerts.message produit alors un bouton « OK » unique.
        await Alerts.message(dialog);

        // Les statuts ont changé : un seul rechargement, après le lot. Les contrats mémorisés sont
        // périmés, on les oublie pour que la prochaine ventilation reparte de données fraîches.
        this.contratsParId = {};
        this.loadTable();
      },

      /**
       * Envoi en signature électronique en masse : enchaîne les étapes de contrôle de la sélection, dans
       * l'ordre de l'US — société (OVA-4979), modèle (OVA-4981), objet du contrat (OVA-4980), puis
       * rubriques employeur et salarié du document (OVA-5011) — et enfin la confirmation (OVA-5011).
       */
      async ouvrirSignatureMasse (): Promise<void> {
        if (this.signaturePreparation || this.signatureEnCours || this.dpaeEnCours || this.dpaePreparation) return;

        this.signaturePreparation = true;
        let aEnvoyer: Contrat[] = [];
        try {
          const contrats = await this.contratsSelectionnes();
          if (contrats.length == 0) return;
          // Un seul contrôle serveur pour toutes les étapes, rechargé après chaque complétion.
          const source = creerSourceControle();
          // Le modèle passe avant l'objet : le champ objet est défini par modèle (OVA-4981, plan §4.3).
          const etapeModele = creerEtapeModele(contrats.length, this.choixModele(), source);
          const etapeObjet = creerEtapeObjetCommun(contrats.length, this.saisieObjet(), source);
          // L'étape document vient en dernier : le rendu du contrat dépend du modèle et de l'objet appliqués.
          const issue = await executerControles(contrats,
            [creerEtapeSociete(source), etapeModele, etapeObjet, creerEtapeDocument(source)], source);
          aEnvoyer = await this.confirmerEnvoiSignature(contrats, issue, etapeModele.bilan(), etapeObjet.bilan());
        } catch {
          // Contrôle impossible (réseau, droits) : un contrôle fait sur des données illisibles ne
          // prouverait rien, on s'arrête sans rien envoyer.
          const dialog = new Dialog();
          dialog.label = titreModale('Envoi en signature électronique')
            + 'Les informations des contrats n\'ont pas pu être vérifiées.<br>'
            + 'Aucun contrat n\'a été envoyé. Réessayez dans quelques instants.';
          await Alerts.message(dialog);
        } finally {
          this.signaturePreparation = false;
          this.modeleVisible = false;
          this.modeleEnCours = false;
          this.objetVisible = false;
          this.objetEnCours = false;
        }
        // Hors du try des contrôles : son message « informations non vérifiées, aucun contrat envoyé »
        // serait faux pendant l'envoi. Le lot ne lève pas, il compte ses échecs.
        if (aEnvoyer.length > 0) {
          await this.executerEnvoiSignature(aEnvoyer);
        }
      },

      /** Envoie le lot par tranches, affiche le compte rendu, puis recharge la liste une seule fois. */
      async executerEnvoiSignature (contrats: Contrat[]): Promise<void> {
        this.signatureTotal = contrats.length;
        this.signatureTraites = 0;
        this.signatureEnCours = true;
        // Suspend les rechargements déclenchés par SignalR pendant toute la durée du lot.
        this.actionProgress = true;

        let resultat: ResultatEnvoiSignature = resultatVide();
        try {
          resultat = await envoyerSignatureParLot(contrats, (traites: number) => {
            this.signatureTraites = traites;
          });
        } finally {
          this.signatureEnCours = false;
          this.actionProgress = false;
        }

        let message = titreModale('Résultat de l\'envoi en signature')
          + `<strong>${resultat.envoyes} contrat(s)</strong> ont été envoyés en signature électronique.`;
        // Le serveur relit chaque contrat : l'un d'eux a pu changer depuis la confirmation. Le dire évite
        // que l'écart entre le nombre annoncé et le nombre envoyé passe pour une perte.
        const ignores: string[] = [];
        if (resultat.ignores > 0) {
          ignores.push(`<strong>${resultat.ignores} contrat(s)</strong> n'étaient plus à envoyer au moment`
            + ' du traitement : déjà envoyés ou signés.');
        }
        message += detailVentilation(ignores);
        message += detailVentilation(regrouperMotifs(resultatsDe(resultat, ISSUE_A_COMPLETER))
          .map(({ motif, nombre }) => `<strong>${nombre} contrat(s)</strong> : ${motif}.`), 'Contrats à compléter');
        message += detailVentilation(regrouperMotifs(resultatsDe(resultat, ISSUE_ECHEC))
          .map(({ motif, nombre }) => `<strong>${nombre} contrat(s)</strong> : ${motif}.`), 'Échecs techniques');
        const dialog = new Dialog();
        dialog.label = message;
        // `buttons` laissé vide : Alerts.message produit alors un bouton « OK » unique.
        await Alerts.message(dialog);

        // Les statuts ont changé : un seul rechargement, après le lot. Les contrats mémorisés sont
        // périmés, on les oublie pour que la prochaine sélection reparte de données fraîches.
        this.contratsParId = {};
        this.loadTable();
      },

      /**
       * Pilotage de la modale de choix du modèle pour l'étape modèle, sur le principe de `saisieObjet` :
       * après validation, la modale reste ouverte, en cours, jusqu'à `terminer`.
       */
      choixModele (): ChoixModele {
        return {
          demander: (selectionnes: number, aChoisir: number, modeles: ModeleProposable[]): Promise<number | null> => {
            this.modeleSelectionnes = selectionnes;
            this.modeleAChoisir = aChoisir;
            this.modeleOptions = modeles;
            this.modeleEnCours = false;
            this.modeleVisible = true;
            return new Promise((resolve) => {
              this.modeleReponse = resolve;
            });
          },
          terminer: (): void => {
            this.modeleVisible = false;
            this.modeleEnCours = false;
            this.modeleReponse = null;
          },
        };
      },
      validerModele (contratTemplateId: number): void {
        this.modeleEnCours = true;
        this.modeleReponse?.(contratTemplateId);
      },
      annulerModele (): void {
        this.modeleVisible = false;
        this.modeleReponse?.(null);
      },

      /**
       * Pilotage de la modale d'objet commun pour l'étape objet. Après validation, la modale reste
       * ouverte, en cours, le temps de l'enregistrement : l'étape la ferme par `terminer`.
       */
      saisieObjet (): SaisieObjet {
        return {
          demander: (selectionnes: number, sansObjet: number): Promise<string | null> => {
            this.objetSelectionnes = selectionnes;
            this.objetSansObjet = sansObjet;
            this.objetEnCours = false;
            this.objetVisible = true;
            return new Promise((resolve) => {
              this.objetReponse = resolve;
            });
          },
          terminer: (): void => {
            this.objetVisible = false;
            this.objetEnCours = false;
            this.objetReponse = null;
          },
        };
      },
      validerObjet (objet: string): void {
        this.objetEnCours = true;
        this.objetReponse?.(objet);
      },
      annulerObjet (): void {
        this.objetVisible = false;
        this.objetReponse?.(null);
      },

      /**
       * Confirmation de l'envoi (OVA-5011) : répartit toute la sélection, rappelle ce que les étapes ont
       * appliqué et pourquoi des contrats restent à compléter, puis demande l'accord. Renvoie les contrats
       * à envoyer, ou une liste vide si l'utilisateur annule ou si aucun contrat n'est envoyable.
       */
      async confirmerEnvoiSignature (contrats: Contrat[], issue: IssueControles, modele: BilanModele,
        objet: BilanObjet): Promise<Contrat[]> {
        const repartition = repartirEnvoi(contrats, issue);
        const envoyables = repartition.envoyables.length;

        // Motifs des seuls contrats comptés en « informations manquantes » : un contrat déjà signé d'une
        // société incomplète est aussi écarté par l'étape société, mais il est compté en « déjà signé ».
        const exclusions = contrats
          .filter((contrat) => STATUTS_ENVOYABLES.includes(contrat.statut))
          .map((contrat) => issue.exclusions.get(contrat.id))
          .filter((exclusion): exclusion is Exclusion => exclusion != undefined);
        // Les étapes modèle et objet partagent l'étape CONTRAT : on les distingue par le code du manque.
        const exclusPour = (codes: ControleSignatureMasseManqueCodes[]): number => exclusions
          .filter((exclusion) => exclusion.manques.some((manque) => codes.includes(manque.code))).length;
        const societe = exclusions.filter((exclusion) => exclusion.etape == 'SOCIETE').length;
        const aucunModele = exclusPour([MANQUE_AUCUN_MODELE]);
        const modeleNonChoisi = exclusPour([MANQUE_MODELE_A_CHOISIR]);
        const sansObjet = exclusPour([MANQUE_OBJET]);
        const salarieAbsent = exclusPour([MANQUE_SALARIE_ABSENT]);
        const creneauxManquants = exclusPour([MANQUE_CRENEAUX_MANQUANTS]);
        const employeurIncomplet = exclusPour([MANQUE_EMPLOYEUR_INCOMPLET]);
        const salarieIncomplet = exclusPour([MANQUE_SALARIE_INCOMPLET]);
        const paragraphe = (texte: string, espace = 0): string =>
          `<div style="padding-top:${espace}px">${texte}</div>`;

        let message = titreModale('Envoi des contrats en signature')
          + paragraphe(`Vous avez sélectionné <strong>${contrats.length} contrat(s)</strong>.`);
        const lignes: string[] = [];
        if (envoyables > 0) {
          lignes.push(`<strong>${envoyables}</strong> pouvant être envoyé(s) en signature ;`);
        }
        if (repartition.informationsManquantes > 0) {
          lignes.push(`<strong>${repartition.informationsManquantes}</strong> présentant encore des informations`
            + ' manquantes ;');
        }
        if (repartition.dejaSignes > 0) {
          lignes.push(`<strong>${repartition.dejaSignes}</strong> déjà signé(s) ;`);
        }
        if (repartition.dejaEnvoyes > 0) {
          lignes.push(`<strong>${repartition.dejaEnvoyes}</strong> déjà envoyé(s) en signature ;`);
        }
        if (repartition.nonConcernes > 0) {
          lignes.push(`<strong>${repartition.nonConcernes}</strong> non concerné(s) : non gérés, annulés ou pas`
            + ' encore calculés ;');
        }
        // La dernière ligne de l'énumération se termine par un point.
        lignes.push(lignes.pop()!.replace(/ ;$/, '.'));
        message += detailVentilation(lignes);

        const fait: string[] = [];
        if (modele.appliques > 0) {
          fait.push(`Modèle appliqué à <strong>${modele.appliques} contrat(s)</strong>.`);
        }
        if (objet.appliques > 0) {
          fait.push(`Objet appliqué à <strong>${objet.appliques} contrat(s)</strong>.`);
        }
        message += detailVentilation(fait, 'Ce qui a été fait');

        const manquants: string[] = [];
        if (societe > 0) {
          manquants.push(`<strong>${societe}</strong> contrat(s) : informations société incomplètes.`);
        }
        if (aucunModele > 0) {
          manquants.push(`<strong>${aucunModele}</strong> contrat(s) : aucun modèle de contrat disponible.`);
        }
        if (modeleNonChoisi > 0) {
          manquants.push(`<strong>${modeleNonChoisi}</strong> contrat(s) : modèle de contrat non choisi.`);
        }
        if (modele.echecs > 0 || modele.erreurTechnique) {
          manquants.push('Le modèle n\'a pas pu être appliqué à certains contrats, qui restent à compléter.');
        }
        if (sansObjet > 0) {
          manquants.push(`<strong>${sansObjet}</strong> contrat(s) : objet du contrat manquant.`);
        }
        if (objet.echecs > 0 || objet.erreurTechnique) {
          manquants.push('L\'objet n\'a pas pu être enregistré sur certains contrats, qui restent à compléter.');
        }
        if (salarieAbsent > 0) {
          manquants.push(`<strong>${salarieAbsent}</strong> contrat(s) : salarié non choisi.`);
        }
        if (creneauxManquants > 0) {
          manquants.push(`<strong>${creneauxManquants}</strong> contrat(s) : périodes de travail non définies.`);
        }
        // Un même contrat peut manquer des deux côtés : il compte alors dans les deux lignes, mais une
        // seule fois dans la répartition.
        if (employeurIncomplet > 0) {
          manquants.push(`<strong>${employeurIncomplet}</strong> contrat(s) : informations employeur manquantes`
            + ' dans le document.');
        }
        if (salarieIncomplet > 0) {
          manquants.push(`<strong>${salarieIncomplet}</strong> contrat(s) : informations salarié manquantes.`);
        }
        message += detailVentilation(manquants, 'Informations manquantes');

        const dialog = new Dialog();
        if (envoyables == 0) {
          message += paragraphe('Aucun contrat ne peut être envoyé en signature.', 14);
          dialog.label = message;
          // `buttons` laissé vide : Alerts.message produit alors un bouton « OK » unique.
          await Alerts.message(dialog);
          return [];
        }

        if (envoyables > SEUIL_AVERTISSEMENT_SIGNATURE) {
          message += paragraphe('L\'envoi portera sur un grand nombre de contrats et peut durer plusieurs'
            + ' minutes.<br>Vous pouvez réduire la sélection à l\'aide des filtres.', 14);
        }
        message += paragraphe(`Confirmez-vous l'envoi en signature électronique de <strong>${envoyables}`
          + ' contrat(s)</strong> ?', 14);
        dialog.label = message;
        dialog.buttons.push('Annuler');
        dialog.buttons.push(BOUTON_ENVOI);
        // Même règle que la DPAE : sans `openAlert`, ou sur toute autre réponse que le bouton d'envoi
        // (Échap), rien ne part. Le bouton d'envoi s'appelle « Confirmer », la réponse de SectionAlert à
        // Entrée : Entrée est neutralisée tant que la confirmation est ouverte.
        if (!openAlert) return [];
        const liberer = neutraliserToucheEntree();
        let reponse = '';
        try {
          reponse = await openAlert(dialog);
        } finally {
          liberer();
        }
        return reponse == BOUTON_ENVOI ? repartition.envoyables : [];
      },

      // Coché : ajoute tous les contrats filtrés. Décoché : ne retire que les contrats
      // filtrés, la sélection hors périmètre est préservée.
      async toggleSelectAll (value: boolean): Promise<void> {
        // Le périmètre filtré est chargé de façon asynchrone (une requête
        // dédiée, pageLimit = -1). Un clic juste après l'ouverture de la liste
        // arriverait avant sa résolution : sans cette attente, il serait sans
        // effet alors que la case apparaîtrait cochée.
        let perimetre = this.filteredIds;
        if (perimetre.length == 0) {
          perimetre = await this.loadFilteredIds(true);
        }
        if (value) {
          const ids = this.selectedIds.slice();
          perimetre.forEach((id) => {
            if (!ids.includes(id)) {
              ids.push(id);
            }
          });
          this.selectedIds = ids;
        } else {
          this.selectedIds = this.selectedIds.filter((id) => !perimetre.includes(id));
        }
      },
      // Ne passe pas par ListBase.applyFilters : ce filtre ne doit pas rejoindre
      // activeFilters, sous peine d'être posté au serveur qui ignore cette colonne.
      applySelectionFilter (choix: ListChoix[]): void {
        // Aucun choix coché, ou les deux cochés, équivaut à "Tous".
        const value = choix.length == 1 ? choix[0].value : SELECTION_ALL;
        if (value == this.selectionFilter) return;
        this.selectionFilter = value;
        this.pageNumber = 1;
        // pageLimit dépend de l'activation du filtre (-1 quand il est actif, 20 sinon) :
        // toute bascule change le périmètre rapatrié et impose de rejouer la requête.
        this.reloadTable();
      },
      hasDocument (contrat: Contrat): boolean {
        let res = false;
        res = contrat.statut >= ContratStatuts.GENERATED;
        return res;
      },
      extendLabel (name: string, item: number, obj: unknown): string | undefined {
        if (name == 'statut') {
          let res = 'En préparation';
          const contrat = obj as Contrat;
          if (contrat) {
            if (contrat.statutDashboard == ContratStatutDashboards.ATTENTE_PRESTATION) {
              res = 'Attente prestation';
            } else if (contrat.statutDashboard == ContratStatutDashboards.A_REGLER) {
              res = 'A régler';
            } else if (contrat.statutDashboard == ContratStatutDashboards.A_SIGNER_EMPLOYEUR) {
              res = 'A signer par l\'employeur';
            } else if (contrat.statutDashboard == ContratStatutDashboards.A_SIGNER_SALARIE) {
              res = 'A signer par le(la) salarié(e)';
            } else if (contrat.statutDashboard == ContratStatutDashboards.PAYER) {
              res = 'Transaction en cours';
            } else if (contrat.statutDashboard == ContratStatutDashboards.TERMINER) {
              res = 'Terminé';
            } else if (contrat.statutDashboard == ContratStatutDashboards.SUPPRIME) {
              res = 'Supprimé';
            } else if (contrat.statutDashboard == ContratStatutDashboards.PRE_PAYEE) {
              res = 'Réglé, validation à venir';
            } else if (contrat.statutDashboard == ContratStatutDashboards.REGLE_A_VALIDER) {
              res = 'Réglé, à valider';
            }
            return res;
          } else {
            return ''
          }
        }
        return undefined;
      },
      getHtmlItem (contrat: Contrat): string {
        return Html.getList(ContratExtend.getData(contrat));
      },
      displayDocument (contrat: Contrat): void {
        if (!this.lockAction) {
          this.lockAction = true;
          Contrat.display(contrat).then(() => {
            this.lockAction = false;
          }).catch(() => {
            this.lockAction = false;
          });
        }
      },
      addItem (): void {
        const contrat = storeContrat.createNewContrat();
        contrat.projetId = this.projet.id;
        storeContrat.createContrat(contrat).then((res) => {
          if (res.id) {
            const route = new Route();
            route.fiche = Fiches.PROJET_CONTRATS;
            route.ficheObjId = res.id;
            this.$emit('selectItem', route);
          } else {
            storeContrat.mContratDeleted(contrat.id);
          }
        });
      },
      canUpdate (contrat: Contrat): boolean {
        return false;
      },
      deleteItem (contrat: Contrat): void {
        storeContrat.deleteContrat(contrat);
      },
      mdiAction (contrat: Contrat): string {
        return 'fas fa-copy';
      },
      hasAction (contrat: Contrat): boolean {
        return true;
      },
      execAction (contrat: Contrat): void {
        this.actionProgress = true;
        Contrat.duplicate(contrat).then(() => {
          this.actionProgress = false;
        }).catch(() => {
          this.actionProgress = false;
        });
      },
    },
  });
</script>
